import { render } from "./button_group.vue?vue&type=template&id=2a924508"
import script from "./button_group.vue?vue&type=script&lang=js"
export * from "./button_group.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__